import {
  FETCH_PUBLICACIONES,
  FETCH_PUBLICACION,
  EDIT_PUBLICACION,
  FETCH_TIPOPUBLICACION,
  IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
  FETCH_ESTADOSVARIACIONES,
  FETCH_MARCAS,
  FETCH_CATEGORIAS,
  FETCH_MOTIVOS,
  SET_FILTRO_PUBLICACIONES,
  SE_MODIFICARON_IMAGENES,
  LOADING_PUBLICACIONES,
  RESET_PUBLICACIONES,
  SET_IMAGES_UPLOADER,
  HAY_CAMBIOS_EN_IMAGENES,
  UPDATE_PUBLICACIONES_LIST,
  RESET_MARCA_Y_CATEGORIA,
  RESET_LIST_PUBLICACIONES,
  UPDATE_PUBLICACIONES_ESTADO,
  FETCH_ALICUOTA_IVA,
  //FETCH_COSTO_FEE,
    //RESET_COSTOS,
  FETCH_ATRIBUTOS_CATEGORIA,
    FETCH_ATRIBUTOS_POR_PUBLICACION,
    FETCH_VALORES_ATRIBUTO,

    FETCH_ATRIBUTOSCATEGORIA,
    FETCH_VALORESATRIBUTO,
    FETCH_ESTRUCTURAATRIBUTOSVALORES,
    FETCH_AGRUPAMIENTOS,
    FETCH_ATRIBUTOSCATEGORIAAGRUPAMIENTO,
    SET_PRODUCTOVALORES,
    SET_HUBO_CAMBIOS_ESTRUCTURA_ATRIBUTOS


} from './types';

import {
  fetchPublicacionesApi,
  fetchPublicacionApi,
  fetchTipoPublicacionApi,
  fetchVariacionesApi,
  fetchMarcasApi,
  fetchCategoriasApi,
  fetchCategoriaApi,
  fetchMotivosRevisionApi,
  fetchPublicacionesEncabezadoApi,
  fetchAlicuotaIvaApi,
    fetchAtributosCategoriaApi,
    fetchValoresAtributoApi,
    fetchEstructuraAtributosValoresApi,
    fetchAgrupamientosApi,
    fetchAtributosPorCategoriaAgrupamientoApi
} from '../api/axios';

import {
  nuevaPublicacion,
  mapPublicacion,
  getIdEstadoPublicacion,
  resetPublicacion
} from '../helper/publicacionHelper'

const toArray = (value, alternate) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(alternate)) return alternate;
  return [];
};

export const seModificaronImagenes = (boolean) => dispatch => {
  dispatch({
    type: SE_MODIFICARON_IMAGENES,
    payload: boolean
  });
}

export const setFiltroPublicacion = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_PUBLICACIONES,
    payload: filtro
  });
}

export const fetchPublicaciones = (params) => async dispatch => {
  dispatch({
    type: LOADING_PUBLICACIONES,
    payload: true
  });

  const req = fetchPublicacionesApi(params);
  req.then((publicaciones) => {
    const elementos = Array.isArray(publicaciones?.elementos)
      ? publicaciones.elementos.map((p) => ({
        ...p,
        imagen: Array.isArray(p?.imagenes) ? p.imagenes[0] : null
      }))
      : [];
    const payload = { ...publicaciones, elementos };

    dispatch({
      type: FETCH_PUBLICACIONES,
      payload
    });

    dispatch({
      type: LOADING_PUBLICACIONES,
      payload: false
    });

  })
}


export const fetchPublicacionesEncabezado = (params) => async dispatch => {
    dispatch({
        type: LOADING_PUBLICACIONES,
        payload: true
    });

    const req = fetchPublicacionesEncabezadoApi(params);
    req.then((publicaciones) => {
        const elementos = Array.isArray(publicaciones?.elementos)
            ? publicaciones.elementos.map((p) => ({
                ...p,
                imagen: Array.isArray(p?.imagenes) ? p.imagenes[0] : null
            }))
            : [];
        const payload = { ...publicaciones, elementos };

        dispatch({
            type: FETCH_PUBLICACIONES,
            payload
        });

        dispatch({
            type: LOADING_PUBLICACIONES,
            payload: false
        });

    }).catch(() => {
        dispatch({
            type: FETCH_PUBLICACIONES,
            payload: {
                elementos: [],
                cantidades: {
                    activos: 0,
                    pendientes: 0,
                    enRevision: 0,
                    pausadosConStock: 0,
                    pausadosSinStock: 0,
                    conStockNoPublicados: 0
                },
                cantidadTotal: 0,
                cantidadPagina: 0,
                numeroPagina: 0
            }
        });

        dispatch({
            type: LOADING_PUBLICACIONES,
            payload: false
        });
    });
}

export const fetchTiposPublicacion = (idSeller) => async dispatch => {
  const req = fetchTipoPublicacionApi(idSeller);
  req.then((tipos) => {

    dispatch({
      type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
      payload: true
    });

    dispatch({
      type: FETCH_TIPOPUBLICACION,
      payload: tipos.tiposPublicaciones
    });
  })
}

export const loadedTipoPublicacion = (value) => dispatch => {
  dispatch({
    type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
    payload: value
  });
}

export const fetchPublicacion = (id, idSeller) => async dispatch => {

  dispatch({ type: LOADING_PUBLICACIONES, payload: true });

  if (typeof id !== 'undefined' && typeof idSeller !== 'undefined') {
    return fetchPublicacionApi(id)
      .then(publicacion => {
        dispatch({
          type: FETCH_PUBLICACION,
          payload: mapPublicacion(publicacion.elementos.shift())
        });
      })
      .catch(err => {
        // si querés podés setear una publicación vacía o mostrar toast aquí
      })
      .finally(() => {
        dispatch({ type: LOADING_PUBLICACIONES, payload: false });
      });
  } else {
    const payload = nuevaPublicacion();
    if (idSeller != null && idSeller !== '') {
      const n = Number(idSeller);
      if (!Number.isNaN(n)) {
        payload.idSeller = n;
      }
    }
    dispatch({
      type: FETCH_PUBLICACION,
      payload
    });
    dispatch({ type: LOADING_PUBLICACIONES, payload: false });
  }
};

export const editPublicacion = (publicacion) => dispatch => {
  return new Promise((resolve) => {
    dispatch({
      type: EDIT_PUBLICACION,
      payload: publicacion
    });
    resolve();
  });
}

export const fetchVariaciones = () => async dispatch => {
  const req = fetchVariacionesApi();
  req.then((variaciones) => {

    dispatch({
      type: FETCH_ESTADOSVARIACIONES,
      payload: variaciones.estados
    });
  })
}

export const fetchMarcas = (descripcion = "") => async (dispatch, getState) => {
  const q = (descripcion ?? "").trim();
  // Evitar llamadas vacías/repetidas de react-select ("" al abrir/cerrar),
  // pero permitir la carga inicial cuando todavía no hay opciones.
  if (q.length === 0) {
    const existing = getState?.()?.publicaciones?.marcas;
    if (Array.isArray(existing) && existing.length > 0) return;
  }

  const req = fetchMarcasApi(q);
  req.then((marcas) => {
    const marcasArray =
      Array.isArray(marcas?.elementos) ? marcas.elementos
        : Array.isArray(marcas?.marcas) ? marcas.marcas
          : Array.isArray(marcas?.Marcas) ? marcas.Marcas
            : Array.isArray(marcas?.content) ? marcas.content
              : Array.isArray(marcas?.Content) ? marcas.Content
                : Array.isArray(marcas) ? marcas
                  : [];

    const options = marcasArray
      .map((marca) => ({
        value: marca?.codigo ?? marca?.Codigo ?? 0,
        label: marca?.descripcion ?? marca?.Descripcion ?? ""
      }))
      .filter((item) => item.label !== "");

    dispatch({
      type: FETCH_MARCAS,
      payload: options
    });
  }).catch(() => {
    dispatch({
      type: FETCH_MARCAS,
      payload: []
    });
  });
}

export const fetchCategorias = (descripcion = "") => async (dispatch, getState) => {
  const q = (descripcion ?? "").trim();
  // Evitar llamadas vacías/repetidas de react-select ("" al abrir/cerrar),
  // pero permitir la carga inicial cuando todavía no hay opciones.
  if (q.length === 0) {
    const existing = getState?.()?.publicaciones?.categorias;
    if (Array.isArray(existing) && existing.length > 0) return;
  }

  const req = fetchCategoriasApi(q);
  req.then((categorias) => {
    const categoriasArray =
      Array.isArray(categorias?.elementos) ? categorias.elementos
        : Array.isArray(categorias?.Elementos) ? categorias.Elementos
          : Array.isArray(categorias?.categorias) ? categorias.categorias
            : Array.isArray(categorias?.Categorias) ? categorias.Categorias
              : Array.isArray(categorias?.content) ? categorias.content
                : Array.isArray(categorias?.Content) ? categorias.Content
                  : Array.isArray(categorias) ? categorias
                    : [];
    const options = categoriasArray
      .map((categoria) => ({
        value: categoria?.id ?? categoria?.Id ?? categoria?.codigo ?? categoria?.Codigo ?? 0,
        label: categoria?.descripcion ?? categoria?.Descripcion ?? ""
      }))
      .filter((item) => item.label !== "");

    dispatch({
      type: FETCH_CATEGORIAS,
      payload: options
    });
  }).catch(() => {
    dispatch({
      type: FETCH_CATEGORIAS,
      payload: []
    });
  });
}

export const fetchCategoria = (codigo) => async dispatch => {
  const req = fetchCategoriaApi(codigo);

  req.then((response) => {
    const descripcion = response?.subFamilia?.descripcion
      ?? response?.subFamilia?.Descripcion
      ?? response?.descripcion
      ?? "";
    let options = { value: descripcion, label: descripcion };

    dispatch({
      type: FETCH_CATEGORIAS,
      payload: options
    });
  }).catch(() => {
    dispatch({
      type: FETCH_CATEGORIAS,
      payload: []
    });
  });
}

export const fetchMotivosRevision = () => async dispatch => {
  const req = fetchMotivosRevisionApi();

  req.then((response) => {
    const motivos = toArray(response?.motivos, response?.Motivos);
    dispatch({
      type: FETCH_MOTIVOS,
      payload: motivos
    })
  }).catch(() => {
    dispatch({
      type: FETCH_MOTIVOS,
      payload: []
    });
  });
}

export const resetPublicaciones = () => dispatch => {
dispatch({
  type: RESET_PUBLICACIONES,
  payload: resetPublicacion() 
});
};


export const resetListPublicaciones = () => dispatch => {
  dispatch({
    type: RESET_LIST_PUBLICACIONES,
    payload: []
  });
}

export const updateListPublicaciones = (publicacionesArray, publicacion) => async (dispatch) => {
    // Validación defensiva
    if (!publicacionesArray || !Array.isArray(publicacionesArray.elementos)) {
        console.error("updateListPublicaciones: publicacionesArray.elementos es inválido", publicacionesArray);
        return;
    }

    const elementos = publicacionesArray.elementos.map(item => {
        if (item.idPublicacion === publicacion.idPublicacion) {
            return {
                ...item,
                titulo: publicacion.titulo,
                skuSeller: publicacion.skuSeller,
                skuMarket: publicacion.skuMarket,
                categoria: publicacion.descripcionCategoria,
                precioLista: publicacion.precioLista,
                precioPromocional: publicacion.precioPromocional,
                estado: getIdEstadoPublicacion(publicacion.estado),
                marca: publicacion.descripcionMarca,
                tipoEntrega: publicacion.tipoEntrega[0] === 1 
                    ? "Envio a domicilio o sucursal correo" 
                    : "Retiro en sucursal",
                envioGratis: publicacion.envioGratis,
                tipoPublicacion: publicacion.tipoPublicacion?.descripcion ?? "",
                stock: publicacion.stock
            };
        }
        return item;
    });

    const updatedPublicacionesArray = {
        ...publicacionesArray,
        elementos,
    };

    dispatch({
        type: 'UPDATE_PUBLICACIONES_LIST',
        payload: updatedPublicacionesArray,
    });
};



export const setImagesUploader = (images, values) => dispatch => {
    dispatch({
        type: SET_IMAGES_UPLOADER,
        payload: images
    });

    dispatch({
        type: HAY_CAMBIOS_EN_IMAGENES,
        payload: values
    });
}


export const resetMarcaYCategoria = () => dispatch => {
  dispatch({
      type: RESET_MARCA_Y_CATEGORIA,
      payload: {
          marca: { label: '', value: '' },
          categoria: { label: '', value: '' }
      }
  });
};


export const updateListPublicacionesEstado = (idPublicacion, estado) => (dispatch, getState) => {
  const { publicaciones } = getState().publicaciones;

  const elementosActualizados = publicaciones.elementos.map(item =>
      item.idPublicacion === idPublicacion
          ? { ...item, estado }
          : item
  );

  const publicacionesActualizadas = {
      ...publicaciones,
      elementos: elementosActualizados,
  };

  dispatch({
      type: UPDATE_PUBLICACIONES_ESTADO,
      payload: publicacionesActualizadas,
  });
};

export const fetchTiposAlicuotasIva = () => async dispatch => {
    const req = fetchAlicuotaIvaApi();
    req.then((response) => {

        dispatch({
            type: FETCH_ALICUOTA_IVA,
            payload: response.data.tiposAlicuotaIva,
        });
    })
}



export const fetchAtributosCategoria = (IdSubFamilia) => async dispatch => {

    try {
        const response = await fetchAtributosCategoriaApi(IdSubFamilia);

        const listAtributos = toArray(response?.listAtributos, response?.ListAtributos);
        dispatch({
            type: FETCH_ATRIBUTOSCATEGORIA,
            payload: listAtributos,
        });

        return listAtributos; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const fetchAtributosPorCategoriaAgrupamiento = (IdSubFamilia, idAgrupacion, Descripcion) => async dispatch => {

    try {
        const response = await fetchAtributosPorCategoriaAgrupamientoApi(IdSubFamilia, idAgrupacion, Descripcion);

        const listAtributos = toArray(response?.listAtributos, response?.ListAtributos);
        dispatch({
            type: FETCH_ATRIBUTOSCATEGORIAAGRUPAMIENTO,
            payload: listAtributos,
        });

        return listAtributos; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const fetchValoresAtributo = (idAtributo, descripcion) => async dispatch => {

    try {
        const response = await fetchValoresAtributoApi(idAtributo, descripcion);

        const listValores = toArray(response?.listValores, response?.ListValores);
        dispatch({
            type: FETCH_VALORESATRIBUTO,
            payload: listValores,
        });

        return listValores; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const fetchEstructuraAtributosValores = ({ codProducto, idCategoria }) => async (dispatch) => {

    //const tieneCodProducto = codProducto !== null && codProducto !== undefined && String(codProducto).trim() !== '';
    //const tieneIdCategoria = idCategoria !== null && idCategoria !== undefined;

    if (codProducto == null) {
        codProducto = "";
    }

    if (idCategoria == null) {
        idCategoria = 0;
    }

    try {
       const response = await fetchEstructuraAtributosValoresApi(codProducto, idCategoria);

        const listaEstructura = toArray(response?.listaEstructura, response?.ListaEstructura);
        dispatch({
            type: FETCH_ESTRUCTURAATRIBUTOSVALORES,
            payload: listaEstructura,
        });

        return listaEstructura; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const fetchAgrupamientos = (idCategoria) => async dispatch => {

    try {
        const response = await fetchAgrupamientosApi(idCategoria);

        const listAgrupamiento = toArray(response?.listAgrupamiento, response?.ListAgrupamiento);
        dispatch({
            type: FETCH_AGRUPAMIENTOS,
            payload: listAgrupamiento,
        });

        return listAgrupamiento; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};

export const setEstructuraAtributosValores = (productoValores, huboCambios) => dispatch => {
    dispatch({
        type: SET_PRODUCTOVALORES,
        payload: productoValores
    });
    dispatch({
        type: SET_HUBO_CAMBIOS_ESTRUCTURA_ATRIBUTOS,
        payload: huboCambios
    });
}

export const limpiarEstructuraAtributosValores = () => dispatch => {
    dispatch({
        type: FETCH_ESTRUCTURAATRIBUTOSVALORES,
        payload: null,
    });

    return null; // <-- Necesario para await en el componente
}

export const limpiarAgrupamientos = () => dispatch => {
    dispatch({
        type: FETCH_AGRUPAMIENTOS,
        payload: null,
    });

    return null; // <-- Necesario para await en el componente
}

export const limpiarProductoValores = () => dispatch => {
    dispatch({
        type: SET_PRODUCTOVALORES,
        payload: null,
    });

    return null; // <-- Necesario para await en el componente
}
